import useTranslation from "../../common/translations";
import { createSiteSearchClient } from "../api/search";
import { useEffect, useState } from "react";
export function useSearchResults(query) {
    const { t } = useTranslation("site-search");
    const [loading, setLoading] = useState(false);
    const [groups, setGroups] = useState([]);
    const [noResultSuggestions, setNoResultSuggestions] = useState([]);
    const [error, setError] = useState(null);
    const [lastValidQuery, setLastValidQuery] = useState("");
    const [isTypoFallback, setIsTypoFallback] = useState(false);
    const client = createSiteSearchClient();
    useEffect(() => {
        const trimmedQuery = query.trim();
        // Don't search if query is empty
        if (trimmedQuery.length < 1) {
            setLoading(false);
            setGroups([]);
            setNoResultSuggestions([]);
            setError(null);
            setLastValidQuery("");
            setIsTypoFallback(false);
            client.abort();
            return;
        }
        setLoading(true);
        setError(null);
        client
            .search(trimmedQuery)
            .then((result) => {
            // If undefined, it means the request was aborted - don't change anything
            if (result === undefined)
                return;
            const { groups: nextGroups, noResultSuggestions: nextSuggestions } = result;
            const hasResults = nextGroups.some((g) => g.items.length > 0);
            // If we got results, update everything normally
            if (hasResults) {
                setGroups(nextGroups);
                setNoResultSuggestions([]);
                setLastValidQuery(trimmedQuery);
                setIsTypoFallback(false);
                setLoading(false);
            }
            else {
                // No results - check if this might be a typo
                // If the current query starts with the last valid query, it's likely a typo
                // e.g., "mercede" -> "mercedez"
                const isPossibleTypo = lastValidQuery &&
                    trimmedQuery
                        .toLowerCase()
                        .startsWith(lastValidQuery.toLowerCase()) &&
                    trimmedQuery.length > lastValidQuery.length;
                setNoResultSuggestions(nextSuggestions);
                if (!isPossibleTypo) {
                    // Show empty results — no fallback applies
                    setGroups(nextGroups);
                    setLastValidQuery("");
                    setIsTypoFallback(false);
                }
                else {
                    setIsTypoFallback(true);
                }
                // If isPossibleTypo: keep groups as-is (already holds last valid results)
                setLoading(false);
            }
        })
            .catch((e) => {
            console.warn(e);
            setError(t("search.error.fetch"));
            setNoResultSuggestions([]);
            setIsTypoFallback(false);
            setLoading(false);
        });
        return () => {
            client.abort();
        };
    }, [query]);
    return { loading, error, groups, noResultSuggestions, isTypoFallback };
}
